/**
 * @generated SignedSource<<e7e1ec25a0e1b535c8cfcf2a3002c52b>>
 * @relayHash 704d3c56e0bd45026393036c41dd8ab5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c437b16d197fffd88cd52096efc00007e50ab44681e8bf25b5e746575efcb828

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { srcVirtualAgentBrowseStandardFlowsQuery } from './srcVirtualAgentBrowseStandardFlowsQuery.graphql';

import checkForAiEnabledFF_provider from '@atlassian/jira-relay-provider/src/jsm-va-is-require-ai-enabled.relayprovider';

const node: PreloadableConcreteRequest<srcVirtualAgentBrowseStandardFlowsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "c437b16d197fffd88cd52096efc00007e50ab44681e8bf25b5e746575efcb828",
    "metadata": {},
    "name": "srcVirtualAgentBrowseStandardFlowsQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": checkForAiEnabledFF_provider
    }
  }
};

export default node;
